import { useTranslation } from 'react-i18next'
import { motion } from 'motion/react'
import { Clock, ExternalLink, LogOut } from 'lucide-react'
import { Browser } from '@capacitor/browser'
import { Capacitor } from '@capacitor/core'
import { useAuth } from './AuthContext'

export default function NotInvitedScreen() {
  const { t } = useTranslation('auth')
  const { signOut, user } = useAuth()

  const openContact = async () => {
    const url = 'https://tend.bot/contact'
    if (Capacitor.isNativePlatform()) {
      await Browser.open({ url })
    } else {
      window.open(url, '_blank')
    }
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-full px-8 pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-sm"
      >
        <div className="text-center mb-10">
          <img src="/tendbot.png" alt="TendBot" className="h-20 w-auto mx-auto mb-3" />
          <h1 className="font-display text-4xl text-gold font-semibold mb-2">TendBot</h1>
        </div>

        <div className="glass-card rounded-2xl p-6 glow-gold text-center">
          <div className="w-14 h-14 rounded-full bg-gold/10 flex items-center justify-center mx-auto mb-4">
            <Clock size={24} className="text-gold" />
          </div>

          <h2 className="font-display text-xl text-ivory font-semibold mb-3">
            {t('notInvited')}
          </h2>
          <p className="text-pearl/80 text-sm leading-relaxed mb-2">
            {t('notInvitedDescription')}
          </p>
          {user?.email && (
            <p className="text-pearl/60 text-xs mb-6">
              {user.email}
            </p>
          )}

          <button
            onClick={openContact}
            className="w-full py-3 rounded-xl bg-gold/10 border border-gold/30 text-gold font-medium text-sm hover:bg-gold/20 transition-colors flex items-center justify-center gap-2 mb-2"
          >
            <ExternalLink size={14} />
            {t('notInvitedContactCta')}
          </button>

          <button
            onClick={() => signOut()}
            className="w-full py-3 rounded-xl bg-slate-mid/30 border border-gold/10 text-pearl/80 font-medium text-sm hover:bg-slate-mid/50 transition-colors flex items-center justify-center gap-2"
          >
            <LogOut size={14} />
            {t('signOutAndTryAnother')}
          </button>
        </div>
      </motion.div>
    </div>
  )
}
